import type { FunctionComponent } from "react";
import Highlighter from "react-highlight-words";
import { HIGHLIGHT_PROPS } from "components/company/CompanyTable/CompanyName/constants";
import useJobCellProps from "./useJobCellProps";

export interface JobCellProps {
  title?: string;
  id?: string;
  archived?: string;
}

const JobCell: FunctionComponent<JobCellProps> = function ({
  title,
  id,
  archived = "",
}) {
  const { searchWords, classNames } = useJobCellProps(archived);

  return (
    <div className="flex flex-col">
      <Highlighter
        {...HIGHLIGHT_PROPS}
        searchWords={searchWords}
        textToHighlight={title || ""}
        className={classNames.title}
      />
      <Highlighter
        {...HIGHLIGHT_PROPS}
        searchWords={searchWords}
        textToHighlight={id || ""}
        className={classNames.id}
      />
    </div>
  );
};

export default JobCell;
